import { LoyaltyProviderEnum, type LoyaltyProvider } from '@pepperhq/types-sdk';

import { Option } from 'lib/types';

export { LoyaltyProviderEnum, type LoyaltyProvider };

export enum LoyaltyTemplate {
    AD_HOC = 'AD_HOC',
    PSEUDO_CURRENCY = 'PSEUDO_CURRENCY',
    STAMP_CARD = 'STAMP_CARD',
    CLUB = 'CLUB',
    LEVEL = 'LEVEL'
}

export enum LoyaltyScope {
    ITEM = 'ITEM',
    CATEGORY = 'CATEGORY',
    BASKET = 'BASKET',
    ITEM_OR_CATEGORY = 'ITEM_OR_CATEGORY'
}

export const basketQualificationScopeOptions: Option[] = [
    {
        value: LoyaltyScope.ITEM,
        label: 'a specific product'
    },
    {
        value: LoyaltyScope.CATEGORY,
        label: 'a specific category'
    },
    {
        value: LoyaltyScope.ITEM_OR_CATEGORY,
        label: 'either a product or category'
    },
    {
        value: LoyaltyScope.BASKET,
        label: 'any other product'
    }
];
